<template>
  <v-container fluid>
    <div class="page-title">{{$route.meta.pageTitle}}</div>
    <v-row justify="center">
      <div class="dashboard-wrapper">
        <v-container>
          <v-row justify="end">
            <v-menu
              :close-on-content-click="false"
              v-model="startMenu"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <div style="width:200px">
                  <v-text-field
                    label="예약일자"
                    v-model="selectedDate"
                    prepend-icon="event"
                    readonly dense
                    v-on="on"
                    :disabled="selectedDateFlag"
                  ></v-text-field>
                </div>
              </template>
              <c-date-picker v-model="selectedDate" firstDayOfWeek="1" @input="startMenu = false" :selectedDate="selectedDate" noTitle="true" scrollable="true" locale="ko-kr"></c-date-picker>
            </v-menu>
          </v-row>
          <v-row justify="end" style="height: 55px">
            <v-col>
              <v-switch inset v-model="optimization" label="자동 배차 최적화" disabled></v-switch>
            </v-col>
            <v-col align-self="end">
              <v-range-slider
                label="기준시각"
                v-model="schedulerHeaders"
                min="0"
                max="24"
                tick-size="1"
                thumb-label="always"
              >
                <template v-slot:thumb-label="props">
                  {{ (parseInt(props.value) < 10) ? ('0' + props.value + ':00') : (props.value + ':00') }}
                </template>
              </v-range-slider>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-checkbox
                v-model="disableBreakTime"
                label="휴무 제외"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row align="center" justify="end" style="height: 20px">
            <div class="schedule-index__item" style="background-color: #0086d4;"/>
            <div class="schedule-index__text">출근</div>

            <div class="schedule-index__item" style="background-color: #bbbbbb;"/>
            <div class="schedule-index__text">퇴근/휴무</div>

            <div class="schedule-index__item" style="background-color: #f7b632;"/>
            <div class="schedule-index__text">예약</div>

            <div class="schedule-index__item" style="background-color: #2cccc7;"/>
            <div class="schedule-index__text">휴식</div>

            <div class="schedule-index__item" :style="endScheduleGuideStyle"/>
            <div class="schedule-index__text">종료</div>
          </v-row>
          <v-row justify="start" align="end">

          </v-row>
        </v-container>
        <v-tabs
          v-model="tab"
          background-color="transparent"
        >
          <v-tab v-for="tabItem in tabItems" :key="tabItem.value">{{ tabItem.name}}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="tabItem in tabItems" :key="tabItem.value">
            <v-card
              v-if="tabItem.value === 'horizontal'"
              class="scheduler-card"
            >
              <c-horizontal-scheduler
                  :selectedDate="selectedDate"
                  :headers="schedulerHeaderList"
                  :contents="schedulerContentList"
                  :startTime="schedulerHeaders[0]"
                  :endTime="schedulerHeaders[1]"
                  :is-active="tab === 0"
              >
                <template #vehicleInfo="{ item }">
                  <div class="vehicle-item__title">{{item.title}}</div>
                  <div>{{getVehicleDrivingDistance(item)}}</div>
                </template>
                <template #menuInfo="{ schedule }">
                  <c-scheduler-menu
                      :schedule="schedule"
                      :onReservePageRoute="onReservePageRoute"
                      :onOpenManualReservation="onOpenManualReservation"
                      :onCancelReservationBind="onCancelReservationBind"
                      :onCancelRestReservationCallbackOpen="onCancelRestReservationCallbackOpen"
                      :onDeliveryPageRoute="onDeliveryPageRoute"
                      :onCancelDelivery="cancelDelivery"
                  />
                </template>
              </c-horizontal-scheduler>
            </v-card>
            <v-card
              v-else-if="tabItem.value === 'vertical'"
              class="scheduler-card"
            >
              <c-vertical-scheduler
                :selectedDate="selectedDate"
                :headers="schedulerHeaderList"
                :contents="schedulerContentList"
                :startTime="schedulerHeaders[0]"
                :endTime="schedulerHeaders[1]"
                :is-active="tab === 1"
              >
              <template #vehicleInfo="{ item }">
                <div>{{item.title}}</div>
                <div class="vehicle-driving-item">{{getVehicleDrivingDistance(item)}}</div>
              </template>
              <template #menuInfo="{ schedule }">
                <c-scheduler-menu
                    :schedule="schedule"
                    :onReservePageRoute="onReservePageRoute"
                    :onOpenManualReservation="onOpenManualReservation"
                    :onCancelReservationBind="onCancelReservationBind"
                    :onCancelRestReservationCallbackOpen="onCancelRestReservationCallbackOpen"
                    :onDeliveryPageRoute="onDeliveryPageRoute"
                    :onCancelDelivery="cancelDelivery"
                />
              </template>
              </c-vertical-scheduler>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-row>

    <!--수동배차 dialog-->
    <manual-reserve-dialog
      :open.sync="manualDialogOpen"
      :reservationCheckData.sync="selectedReservation"
      :reservationFlag.sync="reservationChangeFlag"
    ></manual-reserve-dialog>

    <!--todo 공통 component화 필요..?-->
    <!-- 예약 취소 dialog -->
    <v-dialog
      v-model="cancelDialogOpen"
      hide-overlay
      persistent
      width="380"
    >
      <c-card class="white">
        <v-row justify="center" class="ma-5 title font-weight-bold">예약을 취소하시겠습니까?</v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="blue" large block @click="onCancelReservation(1)">예 (승객으로 인한 취소)</c-btn>
        </v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="blue" large block @click="onCancelReservation(2)">예 (관리자에 의한 취소)</c-btn>
        </v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="grey" large block @click="cancelDialogOpen = false">아니오</c-btn>
        </v-row>
      </c-card>
    </v-dialog>

    <delivery-cancel-dialog
      :open.sync="deliveryCancelFlag"
      :delivery-id="cancelDeliveryId"
      @reqCancelDelivery="reqCancelDelivery"
    />
  </v-container>
</template>
<script>
  import ManualReserveDialog from '../CallTaxi/Reserve/ManualReserveDialog';
  import DeliveryCancelDialog from "../../views/CallTaxi/Delivery/DeliveryCancelDialog.vue";
  import CHorizontalScheduler from "../../components/CHorizontalScheduler.vue";
  import CVerticalScheduler from "../../components/CVerticalScheduler.vue";
  import CSchedulerMenu from "../../components/CSchedulerMenu.vue";

  export default {
    components: {DeliveryCancelDialog, ManualReserveDialog, CHorizontalScheduler, CVerticalScheduler, CSchedulerMenu},
    data() {
      return {
        schedulerHeaders: [7, 24],
        schedulerHeaderList: [],
        schedulerContentList: [],
        selectedDate: this.$func.curDateString(),
        schedulerOneMinuteWidth: 1,
        centerAlignGap: 8,

        manualDialogOpen: false, // 수동예약 다이얼로그 flag
        reservationChangeFlag: null, //예약 변경 flag
        selectedReservation: [], // 예약 변경 타겟

        deliveryCancelFlag: false,
        cancelDeliveryId: '',

        calHeight: 0,
        optionsRightPadding: 0,

        disableBreakTime: true, // 휴무 제외 플래그
        cancelDialogOpen: false,
        selectedReservationId: '',

        optimization: false,
        iconHeight: 13,
        iconMarginTop: 19,
        startMenu: false,
        loadComplete: true,
        tab: null,
        tabItems: [
          {
            name: '가로형',
            value: 'horizontal'
          },
          {
            name: '세로형',
            value: 'vertical'
          }
        ]
      }
    },
    computed: {
      optionsStyle() {
        // return {}
        return {paddingRight: this.optionsRightPadding+'px'}
      },
      getIconStyle() {
        const iconHeight = this.iconHeight;
        const iconMarginTop = this.iconMarginTop;
        return {
          height: iconHeight+'px',
          marginTop: iconMarginTop +'px',
        };
      },
      getNowHour() {
        // 오늘이 아닌 경우 제외
        let today = this.$func.curDateString();
        if (this.selectedDate !== today) return null;

        return this.$moment().format('HH:00');
      },
      getNow() {
        let nowLeft = 0;
        // let endLeft = 0;

        // 오늘이 아닌 경우 제외
        let today = this.$func.curDateString();
        if (this.selectedDate !== today) return null;

        nowLeft = this.schedulerOneMinuteWidth * parseInt(this.$moment.duration(this.$moment().diff(this.$moment(this.schedulerHeaders[0], 'H'))).asMinutes());
        // endLeft = startLeft + this.reservationDuration * this.schedulerOneMinuteWidth;
        if(nowLeft < 0) nowLeft = 0;
        return {startLeft: nowLeft, endLeft: nowLeft, color: '#ee2462'}
      },
      getHeaderList() {
        let headerList = [];
        for (let i = this.schedulerHeaders[0]; i < this.schedulerHeaders[1]; i++) {
          headerList.push(this.$moment({hour: i}).format('HH:00'));
        }
        return headerList;
      },
      activateMenuEvent() {
        const userRole = this.$store.state.userInfo.role;
        return userRole === 'MM';
      },
      selectedDateFlag() {
        const userRole = this.$store.state.userInfo.role;
        return userRole === 'TM';
      },
      endScheduleGuideStyle() {
        if (this.tab === 0) {
          return `background: linear-gradient(45deg, #333333, #333333 25%, transparent 25%, transparent 50%, #333333 50%, #333333 75%, transparent 75%, transparent); background-size: 7px 7px`
        } else {
          return 'background: #7F7F7F'
        }
      }
    },
    watch: {
      manualDialogOpen(newVal) {
        if(!newVal && this.reservationChangeFlag && this.reservationChangeFlag === 'success') {
          this.reservationChangeFlag = null;
          this.reqGetScheduleList(this.selectedDate);
        }
      },
      selectedDate(newVal) {
        this.schedulerContentList = [];
        this.reqGetScheduleList(newVal);
      },
      disableBreakTime(newVal, oldVal) {
        if(newVal !== oldVal) {
          this.reqGetScheduleList();
        }
      }
    },
    methods: {
      getItemStyle(data) {
        const style = {
          width: '100%',
          height: '100%',
          position: 'absolute'

        };

        // const nowLeft = this.schedulerOneMinuteWidth * parseInt(moment.duration(moment().diff(moment(this.schedulerHeaders[0], 'H'))).asMinutes());
        // // 현재 시간보다 data의 종료시간이 더 작은 경우 빗금 표시
        // if((data.left+data.width) < nowLeft) {
        if(data.item && data.item.info && data.item.info.resrvState.configValue === 'rs_done') {
          style.background = 'linear-gradient(45deg, #333333, #333333 25%, transparent 25%, transparent 50%, #333333 50%, #333333 75%, transparent 75%, transparent)';
          style.backgroundSize = '6px 6px';
        }
        return style;
      },
      async onOpenManualReservation(reservation) {
        if(reservation) {
          await this.reqGetReservation(reservation.reservationId);
          this.manualDialogOpen = true;
        }
      },
      onReserve() {
        this.reqGetScheduleList(this.selectedDate);
      },
      async reqGetReservation(reservationId) {
        try {
          const res = await this.$api.getReservationWithPassengers(reservationId);
          this.selectedReservation = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqGetReservation'});
        }
      },
      async reqGetScheduleList(selectedDate) {
        try {
          if (!this.loadComplete) {
            return;
          }
          this.loadComplete = false;

          const res = await this.$api.getReservationScheduleByDateGroupByDriver(selectedDate || this.selectedDate)
          const driverIdList = Object.keys(res.data).map(item => item);

          this.schedulerHeaderList = [];
          this.schedulerContentList = [];

          // 스케줄 데이터 정제
          for (let i = 0; i < driverIdList.length; i++) {
            const driverId = driverIdList[i];
            const scheduleList = res.data[driverId];

            const headerListOfDriver = [];
            const contentListOfDriver = [];

            // 운전자 리스트 생성
            // 운전자 별 배정된 예약 스케줄을 삽입
            for (const schedule of scheduleList) {
              const header = this.getHeaderItems(schedule);
              header && headerListOfDriver.push(header);
              const content = this.getContentItems(schedule);
              content && contentListOfDriver.push(content);
            }

            // 휴무제외시 운전자 필터링
            if (headerListOfDriver.length > 0) {
              this.schedulerHeaderList.push(headerListOfDriver);
            }

            contentListOfDriver.forEach(content => {
              content && this.schedulerContentList.push(content);
            })
          }

          this.sortScheduleList(this.schedulerHeaderList, this.schedulerContentList);

          this.loadComplete = true;
        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqGetScheduleList'});
        }
      },
      getHeaderItems({driver, vehicle, driverSchedule, reservation, totalDistance=0, dsDoneDistance, deliveries}) {
        if (this.checkOffWork(driverSchedule)) {
          return null;
        }

        return {
          driverName: driver.name,
          title: vehicle.plateNo,
          driverId: driver.id,
          vehicleId: vehicle.id,
          totalDistance: (totalDistance/1000).toFixed(2),
          dsDoneDistance: (dsDoneDistance/1000).toFixed(2)
        }
      },
      getContentItems({driver, vehicle, driverSchedule, reservation: reservations, totalDistance=0, dsDoneDistance, deliveries}) {
        if (this.checkOffWork(driverSchedule)) {
          return null;
        }
        const items = [];

        const reservationColor = '#f7b632';
        const onWorkColor = '#0086d4';
        const workOffColor = '#bbbbbb';
        const breakTimeColor = '#2cccc7';

        const baseTime = this.$func.stringToDate(this.selectedDate);
        baseTime.set({hours: 0, minutes: 0, seconds: 0});

        items.push({
          id: vehicle.id,
          driverName: driver.name,
          category: 'offWork',
          startTime: this.$func.dateTimeToString(baseTime),
          endTime: this.$func.dateTimeToString(baseTime.add(1, 'days')),
          color: workOffColor,
          item: {
            title: "퇴근/휴무"
          }
        });

        // 출퇴근 시간 존재하는 경우
        if (driverSchedule) {
          let { onWorkTime, endWorkTime } = driverSchedule;
          const item = {
            id: vehicle.id,
            driverName: driver.name,
            category: 'onWork',
            startTime: this.selectedDate + " " + onWorkTime,
            endTime: this.selectedDate + " " + endWorkTime,
            color: onWorkColor,
            item: driverSchedule
          }
          items.push(item);
        }

        // Add delivery icon
        deliveries.forEach(delivery => {
          items.push({
            id: vehicle.id,
            driverName: driver.name,
            category: 'delivery',
            startTime: delivery.expectedStartTime,
            item: delivery
          });
        })

        reservations.forEach((reservation) => {
          const {startTime, endTime, vehicleId: {id}, customerName, departure, destination, resrvState} = reservation;
          if((customerName === departure)&&(customerName === destination)) {
            items.push({
              id: id,
              driverName: driver.name,
              category: 'breakTime',
              startTime,
              endTime,
              color: breakTimeColor,
              item: reservation
            });
          } else{
            items.push({
              id: id,
              drivername: driver.name,
              category: 'reservation',
              startTime,
              endTime,
              color: reservationColor,
              item: reservation
            });
          }
        });

        return items;
      },
      checkOffWork(driverSchedule) {
        //휴무 제외
        if(this.disableBreakTime && (!driverSchedule || driverSchedule.onWorkTime === driverSchedule.endWorkTime)) {
          return true;
        }
        return false;
      },
      sortScheduleList(headerList, contentList) {
        headerList.sort((a, b) => a[0].driverName > b[0].driverName ? 1 : -1);
        // 내부 차량번호별 정렬
        headerList.forEach(header => {
          header.sort((a,b) => a.vehicleId > b.vehicleId ? 1 : -1)
        })
        contentList.sort((a, b) => {
          if (a[0].driverName === b[0].driverName) {
            return a[0].id > b[0].id ? 1 : -1;
          }
          return a[0].driverName > b[0].driverName ? 1 : -1;
        })
      },
      onReservePageRoute(item) {
        this.$router.push(`/reservation/${item.reservationId}`);
      },
      onDeliveryPageRoute(id) {
        this.$router.push(`/delivery/${id}`)
      },
      onCalHeight() {
        const optionsRightPadding = (window.innerWidth/2)-521-245;
        const height = window.innerHeight - 370;
        this.calHeight = height < 300? 300: height;
        this.optionsRightPadding = optionsRightPadding;
      },
      async onCancelReservationBind(reservation) {
        this.selectedReservationId = reservation.reservationId;
        const res = await this.$api.getReservationWithPassengers(this.selectedReservationId);
        this.selectedReservation = res.data;

        this.cancelDialogOpen = true;
      },

      onCancelRestReservationCallbackOpen(reservation) {
        this.$store.commit('alert', {
          open: true, msg: "휴식을 취소하시겠습니까?",
          persistent: true,
          confirm: true,
          callBack: async () => {
            let cancelList = {reservationId: reservation.reservationId, isUserCancel: false};
            await this.$api.addCanceledReservationWithoutCusomter(cancelList);
            this.$store.commit('snackbar', {color: 'blue', msg: '휴식을 취소하였습니다.'});
            this.reqGetScheduleList(this.selectedDate);
          }
        });
      },

      onCancelReservation(type) {
        // 1: 무단취소, 2: 정상취소
        const reservationList = this.selectedReservation.reservationList[0];
        let cancelList = {reservationId : reservationList.reservationId, isUserCancel : type === 1 ? true : false};

        this.reqCancelReservation(cancelList);
        this.cancelDialogOpen = false;
      },
      async reqCancelReservation(canceledReservationList) {
        try {
          await this.$api.addCanceledReservationWithoutCusomter(canceledReservationList);

          // const deleteResvRes = await this.$api.deleteReservation(this.selectedReservationId);

          this.$store.commit('snackbar', {color: 'blue', msg: '예약을 취소하였습니다.'});

          this.reqGetScheduleList(this.selectedDate);
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAddCanceledReservation'});
        }
      },
      getDeliveryParcelType(item) {
        const configParcels = JSON.parse(item.parcelType);
        return configParcels.map(item => item.configName).join();
      },
      cancelDelivery(id) {
        this.cancelDeliveryId = id;
        this.deliveryCancelFlag = true;
      },
      async reqCancelDelivery(data) {
        try {
          await this.$api.cancelDelivery(data);
          await this.reqGetScheduleList(this.selectedDate);
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqCancelDelivery'});
        }
      },
      getVehicleDrivingDistance(item) {
        return `${item.totalDistance}/${item.dsDoneDistance}`;
      }
    },
    mounted() {
      window.addEventListener('resize', this.onCalHeight);
      this.onCalHeight();
    },
    activated() {
      this.reqGetScheduleList(this.selectedDate);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onCalHeight);
    },
  }
</script>
<style scoped>
  .dashboard-wrapper {
    width: 1300px;
    overflow-x: auto
  }

  .scheduler-card {
    background-color: #F7F7F7;
  }

  .schedule-index__item {
    width: 20px;
    height: 14px;
    margin-left: 20px;
    margin-right: 5px
  }
  .schedule-index__text {
    font-size: 14px;
  }
  .vehicle-item__title {
    font-size: 14px;
  }
  .vehicle-driving-item {
    font-size: 10px;
  }
</style>

